var r=function(r){return"rtl"===r.direction};export{r as i};
